import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

export const sendEmail = <T extends Record<string, any>>(
  data: T,
  setFormData: React.Dispatch<React.SetStateAction<T>>,
  initialData: T,
  message: string,
  duration: number,
  templateId: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setLoading(true);
  emailjs
    .send(
      process.env.REACT_APP_EMAIL_JS_SERVICE_ID as string,
      templateId,
      data,
      process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY as string
    )
    .then(
      () => {
        setFormData(initialData);
        setLoading(false);
        toast.success(message, { autoClose: duration });
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong, please try after some time!");
      }
    );
};
